// board
export const HIT_BOARD_STATUS = 'HIT_BOARD_STATUS';
export const RESET_MSG_BOARD = 'RESET_MSG_BOARD';

export const HIT_LIST_BOARD = 'HIT_LIST_BOARD';
export const GET_LIST_BOARD = 'GET_LIST_BOARD';

export const HIT_LIST_MEMBER_BOARD = 'HIT_LIST_MEMBER_BOARD';
export const GET_LIST_MEMBER_BOARD = 'GET_LIST_MEMBER_BOARD';

export const HIT_ADD_BOARD = 'HIT_ADD_BOARD';
export const GET_ADD_BOARD = 'GET_ADD_BOARD';

export const HIT_UPDATE_BOARD = 'HIT_UPDATE_BOARD';
export const GET_UPDATE_BOARD = 'GET_UPDATE_BOARD';

export const HIT_DUPLICATE_BOARD = 'HIT_DUPLICATE_BOARD';
export const GET_DUPLICATE_BOARD = 'GET_DUPLICATE_BOARD';

export const HIT_DELETE_BOARD = 'HIT_DELETE_BOARD';
export const GET_DELETE_BOARD = 'GET_DELETE_BOARD';

export const HIT_INVITE_BOARD = 'HIT_INVITE_BOARD';
export const GET_INVITE_BOARD = 'GET_INVITE_BOARD';
